module.exports = __webpack_public_path__ + "static/img/member-5.a7828ac1.jpg";